import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import ShopifyIcon from '@/assets/svg-components/stacks/ShopifyIcon'
import CommerceLayerIcon from '@/assets/svg-components/stacks/CommerceLayerIcon'
import ContentfulIcon from '@/assets/svg-components/stacks/ContentfulIcon'
import MedusaIcon from '@/assets/svg-components/stacks/MedusaIcon'

import SnowflakeIcon from '@/assets/svg-components/stacks/SnowflakeIcon'
import StripeIcon from '@/assets/svg-components/stacks/StripeIcon'
import AkaneoIcon from '@/assets/svg-components/stacks/AkaneoIcon'
import ContentstackIcon from '@/assets/svg-components/stacks/ContentstackIcon'

import { USECASE_ID } from '@/const/stackTemplates.ts'
import { SparklesIcon, SquareTerminal } from 'lucide-react'
import { useFeatureFlagPayload, useFeatureFlagEnabled } from 'posthog-js/react'

function useEnabledTechStacks() {
  const flagName = 'enabled-tech-stack'

  const isSelectorEnabled = useFeatureFlagEnabled(flagName)
  const enabledTechStacks = (useFeatureFlagPayload(flagName) as string[]) ?? []

  return { isSelectorEnabled, enabledTechStacks }
}

export function TemplateSelector({ onSelect }: { onSelect: (id: string) => void }) {
  const { enabledTechStacks, isSelectorEnabled } = useEnabledTechStacks()
  if (!isSelectorEnabled) {
    return null
  }
  const enabledStacks = stacks.filter(
    stack => enabledTechStacks.includes(stack.id) || stack.id === USECASE_ID.CUSTOM
  )

  return (
    <Select onValueChange={onSelect}>
      <SelectTrigger className="inline-flex w-auto border-none" hasIcon={false}>
        <SelectValue
          placeholder={
            <span className="inline-flex items-center gap-2">
              <SquareTerminal className="size-4" />
              <span>Technology</span>
            </span>
          }
        ></SelectValue>
      </SelectTrigger>
      <SelectContent>
        {enabledStacks.map(({ id, icon: Icon, label }) => (
          <SelectItem key={id} value={id}>
            <div className="flex items-center gap-2">
              <Icon className="size-4" />
              <span>{label}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

// content stack, medusa, commercelayer, nextjs commerce, contentful, snowflake, stripe, akaneo

const stacks = [
  {
    id: USECASE_ID.CUSTOM,
    label: 'Custom',
    icon: SparklesIcon,
  },
  {
    id: USECASE_ID.CONTENTSTACK,
    label: 'Contentstack',
    icon: ContentstackIcon,
  },
  {
    id: USECASE_ID.MEDUSA,
    label: 'Medusa',
    icon: MedusaIcon,
  },
  {
    id: USECASE_ID.COMMERCE_LAYER,
    label: 'Commerce Layer',
    icon: CommerceLayerIcon,
  },
  {
    id: USECASE_ID.NEXTJS_COMMERCE_SHOPIFY,
    label: 'NextJS Commerce + Shopify',
    icon: ShopifyIcon,
  },
  {
    id: USECASE_ID.CONTENTFUL,
    label: 'Contentful',
    icon: ContentfulIcon,
  },
  {
    id: USECASE_ID.SNOWFLAKE,
    label: 'Snowflake',
    icon: SnowflakeIcon,
  },
  {
    id: USECASE_ID.STRIPE,
    label: 'Stripe',
    icon: StripeIcon,
  },
  {
    id: USECASE_ID.AKANEO,
    label: 'Akaneo',
    icon: AkaneoIcon,
  },
]
